module.exports = "<div class=\"progress-linear\"\n    [class.progress-linear--striped]=\"striped\">\n    <div #linearBar role=\"progressbar\" class=\"progress-linear__bar{{type ? '--' + type : ''}}\"\n        aria-valuemin=\"0\"\n        [attr.aria-valuemax]=\"max\"\n        [attr.aria-valuenow]=\"getValue()\"\n        [style.width.%]=\"valueInPercent || getPercentValue()\">\n        <ng-content></ng-content>\n    </div>\n    <span class=\"progress-linear__value\">{{valueInPercent || getPercentValue()}}%</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/progressbar/templates/linear-bar.component.html
// module id = 116
// module chunks = 0 1